import { observer } from "mobx-react"
import { Flex, Form, Input, Select } from "antd"
import useFormInstance from "antd/lib/form/hooks/useFormInstance"

import { ProjectsCollection } from "@src/app/ProjectsCollection"
import UiStore from "@src/app/uiStore"

const { Item } = Form

type CheckoutUpsertLeftProps = {
  isNew: boolean
  projects: ProjectsCollection
}
const CheckoutUpsertLeft = observer(
  ({ isNew, projects }: CheckoutUpsertLeftProps) => {
    return (
      <Flex gap={16} vertical>
        <Item
          label="Checkout name"
          name="name"
          rules={[{ message: "Please input name", required: true }]}
        >
          <Input />
        </Item>

        <Item
          label="Description"
          name="description"
          rules={[{ message: "Please input description", required: true }]}
        >
          <Input />
        </Item>

        <Item
          label="Project"
          name="project_id"
          rules={[{ message: "Please select at least one", required: true }]}
        >
          <Select
            disabled={!isNew}
            loading={projects.isLoading}
            options={projects.selectOptions}
            placeholder="Select one of your projects from the list"
          />
        </Item>

        <Item
          label="Return URL"
          name="return_url"
          rules={[{ message: "Please input correct URL", type: "url" }]}
        >
          <Input />
        </Item>

        <Item label="Theme" name="theme">
          <Select
            options={[
              ...(!UiStore().isTransferioTheme
                ? [{ label: "Dark", value: "dark" }]
                : []),
              { label: "Light", value: "light" },
            ]}
          />
        </Item>
      </Flex>
    )
  },
)

export default CheckoutUpsertLeft
